import React from "react";
import { connect } from "react-redux";
import { AppState } from "src/redux/store";
import ProjectsPage from "src/components/Projects";
import * as Stories from "src/redux/stories";
import { StatusProject } from "src/redux/projects";
import { Loader } from "src/components/Loader";

function mapDispatchToProps(dispatch) {
  return {
    loadActiveProjects: () => dispatch(Stories.fetchProjectsListOnce())
  };
}

function mapStateToProps(state: AppState) {
  return {
    projects: state.projects.projects.filter(
      p => p.status === StatusProject.InProgress
    ),
    isLoading: state.projects.isLoadingProjects
  };
}

type Props = ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps>;

/**
 * Main container of our app, handle common logic:
 * showing available apps etc...
 */
class ProjectsContainerToConnect extends React.Component<Props> {
  componentWillMount() {
    this.props.loadActiveProjects();
  }

  render() {
    if (this.props.isLoading) {
      return <Loader />;
    }

    return <ProjectsPage projects={this.props.projects} />;
  }
}

export const ProjectsContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(ProjectsContainerToConnect);



// WEBPACK FOOTER //
// ./src/containers/ProjectsContainer.tsx